import { Button } from '@material-ui/core';
import { SettingsBackupRestore } from '@material-ui/icons';
import * as React from 'react';
import { connect } from 'react-redux';

import { getDisqualReasonLabel } from 'shared/models/job-stages';

import { setCandidateQualification } from '../actions';
import { IconLabel } from '../core-ui/icon-label';
import { Candidate } from '../state';

interface OwnProps {
    candidate: Candidate;
}

interface ConnectedDispatch {
    setCandidateQualification: (candidate: Candidate, qualified: boolean, stage: string) => void;
}

type RequalifyButtonProps = OwnProps & ConnectedDispatch;

class RequalifyButtonComponent extends React.Component<RequalifyButtonProps> {
    handleRequalifyRequest = () => {
        this.props.setCandidateQualification(this.props.candidate, true, '');
    };
    render() {
        const { candidate } = this.props;
        return (
            <div className="candidate-disqual-info">
                <IconLabel icon="block">
                    <span className="candidate-disqual-reason">{getDisqualReasonLabel(candidate.disqualReason)}</span>
                </IconLabel>
                <Button
                    className="candidate-move-button candidate-move-button-big"
                    color="primary"
                    endIcon={<SettingsBackupRestore />}
                    fullWidth={true}
                    onClick={this.handleRequalifyRequest}
                    variant="contained"
                >
                    Re-qualify
                </Button>
            </div>
        );
    }
}

const mapDispatchToProps: { [action in keyof ConnectedDispatch]: ConnectedDispatch[action] } = {
    setCandidateQualification
};

export const RequalifyButton = connect<undefined, ConnectedDispatch, OwnProps>(
    undefined,
    mapDispatchToProps
)(RequalifyButtonComponent);
